import gql from 'graphql-tag';

export const INVITE_USER = gql`
  mutation InviteUser($deal_interest: String!) {
    inviteUser(deal_interest: $deal_interest)
  }
`;

export const INVITE_DEAL_INTEREST = gql`
  mutation InviteDealInterest($dealId: ID!, $dealInterestId: ID!) {
    inviteDealInterest(dealId: $dealId, dealInterestId: $dealInterestId) {
      dealInterest {
        id
        invited
        workflow_state
      }
      errors
    }
  }
`;

export const SAVE_DEAL_INTEREST = gql `
  mutation SaveDealInterest($dealInterestId: ID!) {
    saveDealInterest(dealInterestId: $dealInterestId) {
      dealInterest {
        id
        saved
      }
      errors
    }
  }
`;

export const SHORTLIST_DEAL_INTEREST = gql `
  mutation ShortlistDealInterest($dealId: ID!, $dealInterestId: ID!) {
    shortlistDealInterest(dealId: $dealId, dealInterestId: $dealInterestId) {
      dealInterest {
        id
        shortlisted
        workflow_state
      }
      errors
    }
  }
`;

export const ARCHIVE_DEAL_INTEREST = gql `
  mutation ArchiveDealInterest($dealId: ID!, $dealInterestId: ID!, $declined: Boolean) {
    archiveDealInterest(dealId: $dealId, dealInterestId: $dealInterestId, declined: $declined) {
      dealInterest {
        id
        workflow_state
      }
      errors
    }
  }
`;

export const SEND_NDA_TO_RECEIVING_PARTY = gql `
  mutation SendNdaToReceivingParty($dealId: ID!, $dealInterestId: ID!) {
    sendNdaToReceivingParty(dealId: $dealId, dealInterestId: $dealInterestId) {
      dealInterest {
        id
        workflow_state
        receiving_party_nda_sent_timestamp
      }
      errors
    }
  }
`;

export const SEND_MEETING_INVITE = gql `
  mutation SendMeetingInvite($input: MeetingInviteInput!) {
    sendMeetingInvite(input: $input) {
      success
      errors
    }
  }
`;

export const SUBMIT_PROPOSAL = gql `
  mutation SubmitProposal($input: SubmitProposalInput!) {
    submitProposal(input: $input) {
      dealInterest {
        id
        proposal
        proposal_letter
        proposal_meeting_availability
        a1
        a2
        a3
        a4
        a5
        workflow_state
      }
      errors
    }
  }
`;

export const CLOSE_DEAL = gql `
  mutation CloseDeal($dealId: ID!, $reasonForClosing: Int!, $otherReason: String) {
    closeDeal(dealId: $dealId, reasonForClosing: $reasonForClosing, otherReason: $otherReason) {
      deal {
        id
        closed
        reason_for_closing
      }
      errors
    }
  }
`;

export const CREATE_OR_UPDATE_DEAL = gql `
  mutation CreateOrUpdateDeal($input: DealInput!) {
    createOrUpdateDeal(input: $input) {
      deal {
        id
        deal_name
        headline
        sub_headline
        list_price
        invitation_deadline
        deal_state
        approval_status
      }
      errors
    }
  }
`;

export const REQUEST_ADDITIONAL_MATCHES = gql `
  mutation RequestAdditionalMatches($dealId: ID!) {
    requestAdditionalMatches(dealId: $dealId) {
      deal {
        id
        last_suggested_matches_empty
      }
      count
      errors
    }
  }
`;

export const REMOVE_SAVED_DEAL_INTEREST = gql `
  mutation RemoveSavedDealInterest($dealId: ID!, $dealInterestId: ID!) {
    removeSavedDealInterest(dealId: $dealId, dealInterestId: $dealInterestId) {
      dealInterest {
        id
        saved
      }
      errors
    }
  }
`;

export const UNINVITE_DEAL_INTEREST = gql `
  mutation UninviteDealInterest($dealId: ID!, $dealInterestId: ID!) {
    uninviteDealInterest(dealId: $dealId, dealInterestId: $dealInterestId) {
      dealInterest {
        id
        invited
        workflow_state
      }
      errors
    }
  }
`;

export const SIGN_RECEIVING_PARTY_NDA = gql `
  mutation SignReceivingPartyNda($dealId: ID!, $dealInterestId: ID!, $signatureData: String!) {
    signReceivingPartyNda(dealId: $dealId, dealInterestId: $dealInterestId, signatureData: $signatureData) {
      dealInterest {
        id
        workflow_state
      }
      errors
    }
  }
`;

export const SIGN_DISCLOSING_PARTY_NDA = gql `
  mutation SignDisclosingPartyNda($dealId: ID!, $dealInterestId: ID!, $signatureData: String!) {
    signDisclosingPartyNda(dealId: $dealId, dealInterestId: $dealInterestId, signatureData: $signatureData) {
      dealInterest {
        id
        workflow_state
      }
      errors
    }
  }
`;

export const SEND_DEAL_MESSAGE = gql `
  mutation SendDealMessage($dealId: ID!, $dealInterestId: ID!, $message: String!) {
    sendDealMessage(dealId: $dealId, dealInterestId: $dealInterestId, message: $message) {
      message {
        id
        content
        sender {
          id
          name
        }
        createdAt
      }
      errors
    }
  }
`;

export const SCHEDULE_DEAL_MEETING = gql `
  mutation ScheduleDealMeeting($input: ScheduleDealMeetingInput!) {
    scheduleDealMeeting(input: $input) {
      scheduledMeeting {
        id
        start_time
        duration
        format
        location
        description
      }
      errors
    }
  }
`;

export const BUYER_DECLINE_INVITATION = gql `
  mutation BuyerDeclineInvitation($dealId: ID!, $dealInterestId: ID!) {
    buyerDeclineInvitation(dealId: $dealId, dealInterestId: $dealInterestId) {
      dealInterest {
        id
        workflow_state
        buyer_declined_date
      }
      errors
    }
  }
`;